import React from 'react'

// No-op route wrapper. Previously this forced a full unmount +
// remount on every URL change (via key={location.pathname}) and
// played a 150ms opacity fade-in afterwards. That animation looked
// fine on a fresh app open but, combined with the inevitable
// remount-on-back from an article detail page, made the news list's
// images visually appear to reload every time the user came back —
// the bytes were cached, the DOM nodes were new, and the fade-in
// "loading" feel was wholly the animation rather than any actual
// network activity.
//
// We rely on the per-hook caches (useNewsArticles, useTodayDigest,
// useTodayTrending, useNewsSources) for fast back-navigation, plus
// the scroll-position store, plus React.memo on the list cards.
// With those in place the page is already instant. The fade was
// the last visible artefact making it look slower than it is.
//
// Keeping the wrapper exported so external callers don't break;
// it's just a pass-through now.
export default function PageTransition({ children }) {
  return children
}
